import * as translator from '../../../../translator'

export const trans = (key, parameters = {}, domain = 'visitmonaco') => {
  try {
    return translator.trans(key, parameters, domain)
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(
        `Erreur de traduction pour la clé "${key?.id}" dans le domaine "${domain}", Avez-vous oublié de mettre en place la traduction ? ou d'executer la commande "php bin/console ezplatform:translations:dump". ?`,
      )
    }
    return `${key?.id}`
  }
}

export const getLocale = () => {
  return translator.getLocale()
}

export const getLocaleUrl = () => {
  const _locale = getLocale()

  return _locale === 'fr' ? null : `/${_locale}`
}

export * from '../../../../translator'
